module.exports = __webpack_public_path__ + "img/underline.770be393.svg";